import React, { FunctionComponent } from 'react';
import { Grid, makeStyles } from '@rbx/ui';
import { useAppConfig } from '@modules/layout/layout/components/AppConfigProvider';
import SecondaryNavbar from '../../features/components/SecondaryNavbar';
import { secondaryNavigationHeight } from '../../layout/constants/layoutConstants';

// reference: https://github.rbx.com/Roblox/unified-creator-site/blob/master/packages/navigation/src/topNavigation/components/TopNavigationBottomHeader.tsx
const useStyles = makeStyles()((theme) => ({
  container: {
    width: '100%',
    flexWrap: 'inherit',
    height: secondaryNavigationHeight,
    padding: '0 47px',
    [theme.breakpoints.down('XLarge')]: {
      padding: '0 32px',
    },
    [theme.breakpoints.down('Medium')]: {
      padding: '0 24px',
    },
  },
}));

const PageNavigation: FunctionComponent<React.PropsWithChildren> = () => {
  const {
    classes: { container },
  } = useStyles();
  const { menu } = useAppConfig();
  if (!menu) {
    return null;
  }
  return (
    <Grid container direction='column' className={container}>
      <SecondaryNavbar
        title={menu.title}
        selectedId={menu.items.find((t) => t.selected)?.path}
        items={menu.items.map(({ title, path }) => ({
          id: path,
          path,
          label: title,
        }))}
      />
    </Grid>
  );
};

export default PageNavigation;
